import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Gallery from "../components/Gallery";
import Testimonials from "../components/Testimonials";
import Visit from "../components/Visit";
import Footer from "../components/Footer";
import useReveal from "../hooks/useReveal";

export default function Home() {
  useReveal();

  useEffect(() => {
    document.title = "Quattro Tavoli – Italienisches Bistro | München";
  }, []);

  return (
    <main className="bg-[#FAF4EA]">
      <Navbar />
      <Hero />
      <About />
      <Gallery />
      <Testimonials />
      <Visit />
      <Footer />
    </main>
  );
}
